import { isPhoneNumberValid } from 'util/Formatting';

const emailRegex: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const validateEmail = (value?: string | number) => value !== undefined && emailRegex.test(`${value}`);

const validatePhoneNumber = (value?: string | number) => isPhoneNumberValid(`${value}`);

export {
  emailRegex,
  validateEmail,
  validatePhoneNumber,
};
